<template>
  <div id="app">
    <Head />
    <router-view />
    <el-backtop :right="50" :bottom="50"></el-backtop>
    <Footer></Footer>
  </div>
</template>

<script>
import Head from "@/components/head.vue";
import Footer from "./components/footer.vue";

export default {
  components: {
    Head,
    Footer
  },
};
</script>

<style lang="scss">
#app{
  overflow: hidden;
}
*{
  padding: 0;
  margin: 0;
}
a{
  text-decoration:none;
}
ul,li{
  list-style: none;
  padding: 0;
}
body{
  overflow-y: auto !important;
}
body::-webkit-scrollbar {
    width: 0em;
    // background-color: #F5F5F5;
}
/* 定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸 */
body::-webkit-scrollbar {
width: 8px; /* 对垂直滚动条有效 */
height: 6px; /* 对水平滚动条有效 */
}

/* 定义滚动条的轨道颜色、内阴影及圆角 */
body::-webkit-scrollbar-track {
border-radius: 4px;
background-color: transparent;
}

/* 定义滑块颜色、内阴影及圆角 */
body::-webkit-scrollbar-thumb {
border-radius: 4px;
background-color: rgba(144, 147, 153, 0.3);
cursor: pointer;
}

/* 定义滑块悬停变化颜色、内阴影及圆角 */
body::-webkit-scrollbar-thumb:hover {
background-color: rgba(144, 147, 153, 0.5);
}

/* 定义右下角汇合处的样式 */
body::-webkit-scrollbar-corner {
background: transparent;
}
</style>
